import React from 'react';
/**
 * Minimalist laptop frame — silver bezel + bottom lip.
 * Keeps focus on the screenshot while suggesting a premium laptop context.
 */
export function LaptopFrame({
  src,
  alt,
  className = ''
}: {
  src: string;
  alt: string;
  className?: string;
}) {
  return <div className={`relative ${className}`} dir="ltr" data-id="element-79">
      {/* Display */}
      <div className="relative rounded-[10px] overflow-hidden" style={{
      background: '#0B1328',
      padding: '3px',
      boxShadow: '0 22px 50px -22px rgba(14,93,85,0.35), 0 8px 24px rgba(26,31,43,0.12)'
    }} data-id="element-80">
        {/* Screen */}
        <div className="rounded-[7px] overflow-hidden flex flex-col aspect-[16/10]" style={{
        background: '#FFFFFF'
      }} data-id="element-81">
          {/* Browser chrome */}
          <div className="flex items-center gap-1 px-2 py-1 border-b shrink-0" style={{
          background: '#F5F7FA',
          borderColor: 'rgba(26,31,43,0.05)'
        }} data-id="element-82">
            <span className="w-1.5 h-1.5 rounded-full" style={{
            background: '#FF6B6B'
          }} data-id="element-83" />
            <span className="w-1.5 h-1.5 rounded-full" style={{
            background: '#FFC857'
          }} data-id="element-84" />
            <span className="w-1.5 h-1.5 rounded-full" style={{
            background: '#2FA99C'
          }} data-id="element-85" />
          </div>
          <div className="flex-1 relative overflow-hidden bg-white" data-id="element-86">
            <img src={src} alt={alt} draggable={false} className="absolute inset-0 w-full h-full object-cover object-top" data-id="element-87" />
          </div>
        </div>
      </div>

      {/* Base / lip */}
      <div className="mx-auto -mt-px rounded-b-[6px]" style={{
      height: '8px',
      width: '108%',
      marginLeft: '-4%',
      background: 'linear-gradient(180deg, #D8DEE9 0%, #B5BDCC 40%, #8F98AB 100%)',
      boxShadow: '0 4px 12px rgba(26,31,43,0.2)'
    }} data-id="element-88">
        {/* Trackpad notch */}
        <div className="mx-auto rounded-b-md" style={{
        width: '14%',
        height: '3px',
        background: 'rgba(26,31,43,0.22)'
      }} data-id="element-89" />
      </div>
    </div>;
}